module.exports = __webpack_public_path__ + "static/img/rank_152.b220cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_152.png
// module id = i7Aj
// module chunks = 1